import { createSelector } from 'reselect';

// Config
import { getOrderDetailsIsClickCollectOrderSelector } from '@redux/reducers/order-form/orderFormSelector';
import { getPaymentProcessingSelector } from '@redux/reducers/payment/paymentSelector';

const editDetailsLinkState = createSelector(
  [getOrderDetailsIsClickCollectOrderSelector, getPaymentProcessingSelector],
  (isClickCollectOrder, paymentProcessing) => ({
    isClickCollectOrder,
    paymentProcessing,
  }),
);

export default editDetailsLinkState;
